import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import './Slider.css';

function Slider({children, settings = {} }) {

    const defaultSettings = {
        arrows : false,
        type: 'loop',
        width  : '100%',
        interval: 5000,
        gap    : '1rem',
        autoplay     : true,
        pauseOnHover : false,
        pauseOnFocus:　false
    }

    const options = {
        ...defaultSettings,
        ...settings
    }

    return(
        <Splide
          options={options}
        >
            {children.map((item, i) => (
                <SplideSlide key={i}>
                    {item.props.children }
                </SplideSlide>
            ))}
        </Splide>
    );
}
export default Slider;